import React from 'react'
import {CatalogSkill, Skill} from '@api/models'
import LabelWithImage from '@_metronic/partials/layout/editsim-drawer/EditSimCatalogParams/components/CatalogField/components/LabelWithImage'
import styled from 'styled-components'

type SimSkillProps = {
  skill: Skill | undefined
  level: number
}

const SimSkill = ({skill, level}: SimSkillProps) => {
  const Progress = styled.div`
    position: absolute;
    left: 0;
    top: 0;

    background: rgba(80, 205, 137, 1);
    height: 100%;
    width: ${level * 10}%;
  `
  const ProgressSpan = styled.span`
    z-index: 2;
    font-size: 11px;
    position: absolute;
    left: 5px;
    font-weight: bold;
    color: ${level === 0 ? 'black' : 'white'};
  `
  return (
    <div className={'d-flex gap-3 align-items-center'}>
      <LabelWrapper>
        <LabelWithImage
          label={
            <OverflowText className={'fw-semibold text-gray-800 fs-6'}>
              {(skill && `${skill.label}`) || ''}
            </OverflowText>
          }
          imageUrl={skill && skill.imageUrl}
        />
      </LabelWrapper>

      <ProgressWrapper>
        <ProgressSpan>{level}</ProgressSpan>
        <Progress />
      </ProgressWrapper>
    </div>
  )
}

const ProgressWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  border: 1px solid rgba(230, 231, 235, 1);
  height: 20px;
`

const LabelWrapper = styled.div`
  max-width: 90%;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
`

const OverflowText = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`
export default SimSkill
